import { SITE_BASE_URL } from '../../constants/site';

/**
 * Converts string value into a slug for urls
 */
export const convertToSlug = (subject: string): string => {
	return subject.trim().replace(/\W/g, '-').toLowerCase();
};

/**
 * Takes a full path and strips out the query string if it exists
 */
export function extractPathName(fullPath: string): string {
	const url = new URL(fullPath, SITE_BASE_URL);
	return url.pathname;
}

/**
 * Determines if a URL is external.
 */
export const isExternalUrl = (url: string): boolean => {
	try {
		const parsed = new URL(url, SITE_BASE_URL);
		return parsed.origin !== SITE_BASE_URL;
	} catch {
		return false;
	}
};
